/* ==========================================================================
   Candela — theme-color meta

   Chrome on Android and Safari up to iOS 18 tint their chrome from theme-color.
   Safari 26 ignores it: it hit-tests the viewport edges and reads the fixed
   element it finds there (announcement bar, checkout bar), so those carry their
   own background-color and hidden overlays are visibility:hidden — see
   candela-cart.css and candela-nav.css. This file only serves the browsers that
   still honour the tag.

   theme.liquid renders the correct value already; this keeps it right when the
   bars change after load.
   ========================================================================== */

(function () {
  var meta = document.getElementById('CandelaThemeColor');
  if (!meta) return;

  var root = document.documentElement;

  function isDark() {
    if (document.getElementById('CandelaAnnouncement')) return true;

    var bar = document.getElementById('CandelaCartBar');
    if (bar && bar.classList.contains('is-visible')) return true;

    return false;
  }

  function update() {
    var token = isDark() ? '--color-foreground' : '--color-background';
    var rgb = getComputedStyle(root).getPropertyValue(token).trim();
    if (!rgb) return;

    var value = 'rgb(' + rgb + ')';
    if (meta.getAttribute('content') !== value) meta.setAttribute('content', value);
  }

  /* The checkout bar is toggled from candela-cart-updates.js and again from
     candela-quick-add.js, and the announcement bar is removed outright by
     candela-nav.js. Observing the result covers all three without three hooks. */
  var bar = document.getElementById('CandelaCartBar');
  if (bar) {
    new MutationObserver(update).observe(bar, {
      attributes: true,
      attributeFilter: ['class'],
    });
  }

  if (document.body) {
    new MutationObserver(update).observe(document.body, { childList: true });
  }

  /* A bfcache restore repaints without re-running the document. */
  window.addEventListener('pageshow', update);

  update();
})();
